import {Bot, BrainCircuit, Code2, Cpu, Network, ShieldCheck, Zap} from 'lucide-react';
import {memo, ReactElement} from 'react';
import workJson from 'static_configs/work.json';
import {HighlightItem, WorkContent} from 'types';

const content = workJson as WorkContent;

const iconMap: Record<string, ReactElement> = {
  agent: <Bot aria-hidden="true" />,
  ai: <BrainCircuit aria-hidden="true" />,
  compiler: <Code2 aria-hidden="true" />,
  privacy: <ShieldCheck aria-hidden="true" />,
  systems: <Cpu aria-hidden="true" />,
  network: <Network aria-hidden="true" />,
  performance: <Zap aria-hidden="true" />
};

function HighlightCard({item}: { item: HighlightItem }): ReactElement {
  return (
    <article className="feature-card">
      <div className="feature-icon">{item.icon ? iconMap[item.icon] : iconMap.compiler}</div>
      <p className="eyebrow">{item.eyebrow}</p>
      <h3>{item.title}</h3>
      <p>{item.body}</p>
    </article>
  );
}

function WorkSection(): ReactElement {
  return (
    <div className="section-inner work-root">
      <div className="section-heading">
        <p className="eyebrow">{content.eyebrow}</p>
        <h2>{content.title}</h2>
        <p>{content.body}</p>
      </div>

      <div className="feature-grid">
        {content.focusAreas.map((item) => (
          <HighlightCard key={item.eyebrow} item={item} />
        ))}
      </div>

      <div className="black-panel">
        <div>
          <p className="eyebrow">Areas</p>
          <h3>AI agents, backend AI systems, local LLM automation, compilers, distributed systems.</h3>
        </div>
        <div className="capability-list">
          {content.capabilities.map((capability) => (
            <span key={capability}>{capability}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export const Work = memo(WorkSection);
